export default __webpack_public_path__ + "static/media/FFE74BD5-9CC2-4123-B35B-3B44B8F53943.4957fcc1.jpeg";